'use es6';

import Raven from 'raven-js';
const ERROR_SUFFIX = {
  'Aborting: redirection in progress': ': AUTH_REDIRECT',
  'Network request failed': ': NETWORK_FAILED',
  'Request aborted': ': ABORTED',
  'Request timeout': ': TIMEOUT'
};
const INFO_LEVEL_TYPES = {
  CAMPAIGN_LIST_EARLY_REQUEST_FETCH_SUCCEEDED: true,
  AUDIENCE_CREATE_FAILED: true,
  CAMPAIGN_LIST_FETCH_SUCCEEDED: true,
  PIXELS_FETCH_SUCCEEDED: true,
  LEAD_AD_CREATE_FAILED: true,
  CAMPAIGN_REPORTING_ENTITY_UPDATE_FAILED: true,
  CAMPAIGN_DETAILS_FETCH_FAILED: true,
  CHILDREN_BY_ENTITY_FETCH_FAILED: true,
  AUDIENCES_FETCH_SUCCEEDED: true,
  AUDIENCES_INACTIVE_FETCH_SUCCEEDED: true,
  NETWORK_AGGREGATE_DATA_FETCH_FAILED: true,
  AUTOMATE_LIST_CREATE_FAILED: true,
  LEAD_FORMS_FETCH_FAILED: true,
  LEAD_AD_FETCH_LEAD_SYNCING_ENTITIES_FAILED: true,
  USER_ATTRIBUTES_FETCH_FAILED: true,
  LEAD_FORMS_CREATE_FAILED: true,
  CAMPAIGN_INFO_FETCH_FAILED: true,
  AUDIENCES_FETCH_FAILED: true,
  PIXELS_FETCH_FAILED: true,
  PIXEL_CREATE_FAILED: true,
  ESTIMATED_SIZE_FETCH_FAILED: true
};

const failedActionSuffix = action => {
  if (!action.meta || !(action.meta.statusText || action.meta.message)) {
    // Possibly and ad blocker or some other hard-fail on the client side where
    // we don't get any data to debug
    if (action.meta && action.meta.status === 0 && !action.meta.statusText) {
      return ': NO_DATA';
    }

    return '';
  }

  const {
    meta: {
      message,
      statusText
    }
  } = action;
  return ERROR_SUFFIX[statusText] || ERROR_SUFFIX[message] || '';
};

const determineLogLevel = type => {
  if (INFO_LEVEL_TYPES[type]) {
    return 'info';
  }

  return 'error';
};

export default (action => {
  const {
    type
  } = action;
  const errorSuffix = failedActionSuffix(action);
  const adNetworks = []; // a better long term solution might be to normalize the response structure we receive
  // the most common action response structures are:
  //    {payload: {accountErrors:[{adNetwork}]}}
  //    {payload: {errors: [{adNetwork}]}}
  //    {payload: {network}}
  //    {payload: {filters: {network}}}

  if (action.payload) {
    if (action.payload.accountErrors) {
      action.payload.accountErrors.forEach(accountError => {
        adNetworks.push(accountError.adNetwork);
      });
    } else if (action.payload.errors) {
      action.payload.errors.forEach(accountError => {
        adNetworks.push(accountError.adNetwork);
      });
    } else if (action.payload.filters) {
      adNetworks.push(action.payload.filters.network);
    } else {
      adNetworks.push(action.payload.network);
    }
  }

  Raven.captureMessage(`${type}${errorSuffix}`, {
    level: determineLogLevel(type),
    tags: {
      adNetworks
    },
    extra: {
      action
    }
  });
});